import { render, staticRenderFns } from "./IconSad.vue?vue&type=template&id=5b6a091d&"
import script from "./IconSad.vue?vue&type=script&lang=js&"
export * from "./IconSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports